package com.havn.app.core.logging

actual object HavnLogger {
    actual fun debug(category: String, message: String) {
        console.log("HAVN DEBUG [$category] $message")
    }

    actual fun info(category: String, message: String) {
        console.info("HAVN INFO [$category] $message")
    }

    actual fun warning(category: String, message: String, throwable: Throwable?) {
        console.warn("HAVN WARN [$category] $message ${throwable?.message.orEmpty()}")
    }

    actual fun error(category: String, message: String, throwable: Throwable?) {
        console.error("HAVN ERROR [$category] $message ${throwable?.message.orEmpty()}")
    }
}
